<div id="st-leaderboardsidebar-sidebar-container" class="sidebar-container">
  <!-- Sidebar Header -->
  <header class="sidebar-header">
    <div id="st-leaderboardsidebar-header-content" class="header-content">
      <button class="mobile-back-btn" type="button" (click)="closeSidebar()" (keydown.enter)="closeSidebar()" (keydown.space)="$event.preventDefault(); closeSidebar()" aria-label="Back" tabindex="0">
        ←
      </button>
      <h2>{{ 'filter' | translate }}</h2>
    </div>
    <div id="st-leaderboardsidebar-header-actions" class="header-actions">
      <button class="header-clear-btn" type="button" (click)="clearFilters()" (keydown.enter)="clearFilters()" (keydown.space)="$event.preventDefault(); clearFilters()" tabindex="0">
        {{ 'clear_all' | translate }}
      </button>
      <button class="close-btn" type="button" (click)="closeSidebar()" (keydown.enter)="closeSidebar()" (keydown.space)="$event.preventDefault(); closeSidebar()" tabindex="0">✖</button>
    </div>
  </header>
  <div id="st-leaderboardsidebar-sidebar-content" class="sidebar-content">
    <div id="st-leaderboardsidebar-left-pane" class="left-pane">
      <ng-container *ngIf="getDisplayableRoles().length > 0">
        <button *ngFor="let role of getDisplayableRoles(); trackBy: trackById" class="tab"
          [class.active]="activeTab === 'club' && activeRoleId === role.parent_role_id"
          (click)="setActiveRoleTab(role.parent_role_id)" (keydown.enter)="setActiveRoleTab(role.parent_role_id)" (keydown.space)="$event.preventDefault(); setActiveRoleTab(role.parent_role_id)" tabindex="0">
          <span class="tab-label">{{ role.parent_role_name }}</span>
          <span *ngIf="getSelectedCountForRole(role) > 0" class="filter-count-badge">
            {{ getSelectedCountForRole(role) }}
          </span>
        </button>
      </ng-container>
      
      
      <button class="tab" [class.active]="activeTab === 'rank'" (click)="setActiveTab('rank')" (keydown.enter)="setActiveTab('rank')" (keydown.space)="$event.preventDefault(); setActiveTab('rank')" tabindex="0">
        <span class="tab-label">{{ 'rank' | translate }}</span>
        <span *ngIf="getSelectedRankCount() > 0" class="filter-count-badge">
          {{ getSelectedRankCount() }}
        </span>
      </button>
      
    </div>
    <div id="st-leaderboardsidebar-right-pane" class="right-pane">
      <div id="st-leaderboardsidebar-club-tab-panel" *ngIf="activeTab === 'club'" class="club-tab-panel d-flex flex-column gap-3 overflow-hidden">
        <ng-container *ngIf="getDisplayableRoles().length > 0 && getActiveRole() as activeRole; else clubFallback">
          <h3>
            <ng-container
              *ngIf="
                filterTitleKeyByRole[activeRole.parent_role_name] as filterTitleKey;
                else genericFilterTitle
              "
            >
              {{ filterTitleKey | translate }}
            </ng-container>
            <ng-template #genericFilterTitle>
              {{ 'filter_by' | translate }}
              {{ activeRole.parent_role_name | translate }}
            </ng-template>
          </h3>
          <div id="st-leaderboardsidebar-search-container" class="search-container">
            <img src="../../../../assets/ranking-rating_assets/search_icon_p3.svg" alt="Search Icon"
              class="search-icon" />
            <input type="text"
              [placeholder]="'search_for_name' | translate:{name: getActiveRole()?.parent_role_name || 'Clubs'}"
              class="search-input" [(ngModel)]="searchValue" (input)="onSearch()" />
          </div>
          <ng-container *ngTemplateOutlet="clubOptionsTemplate"></ng-container>
        </ng-container>
        <ng-template #clubFallback>
          <h3>{{ 'filter_by_club' | translate }}/MA</h3>
          <div id="st-leaderboardsidebar-search-container-1" class="search-container">
            <img src="../../../../assets/ranking-rating_assets/search_icon_p3.svg" alt="Search Icon"
              class="search-icon" />
            <input type="text" [placeholder]="'search_for_name' | translate:{name: 'Clubs'}" class="search-input"
              [(ngModel)]="searchValue" (input)="onSearch()" />
          </div>
          <ng-container *ngTemplateOutlet="clubOptionsTemplate"></ng-container>
        </ng-template>
        <ng-template #clubOptionsTemplate>
          <div id="st-leaderboardsidebar-club-options" #clubOptionsList class="club-options" *ngIf="clubs.length > 0 || clubsLoading; else clubListEmpty"
            (scroll)="onClubOptionsScroll($event)">
            <label *ngFor="let club of clubs; trackBy: trackById" class="club-option">
              <input type="checkbox" [checked]="selectedClubs[club.user_role_id]"
                (change)="onClubSelect(club.user_role_id)" />
              {{ club.name }}
            </label>
            @if (clubsLoading) {
            <stupa-skeleton-loader id="st-leaderboardsidebar-club-list-loader" class="py-2" [rows]="3" [columns]="1" />
            }
          </div>
          <ng-template #clubListEmpty>
            <p *ngIf="!clubsLoading">{{ 'no_records_found_for_name' | translate:{name: getActiveRole()?.parent_role_name || 'Clubs'} }}</p>
          </ng-template>
        </ng-template>
      </div>
      <div id="st-leaderboardsidebar-block" *ngIf="activeTab === 'period'">
        <h3>{{ 'filter_by_season' | translate }}</h3>
        <select class="season-dropdown" [(ngModel)]="selectedSeasonId" (ngModelChange)="onSeasonSelect($event)">
          <option value="">{{ 'none' | translate }}</option>
          <option *ngFor="let season of seasons; trackBy: trackById" [value]="getSeasonIdValue(season.id)">
            {{ season.season_name }}
          </option>
        </select>
        <div id="st-leaderboardsidebar-timeline-options" class="timeline-options" *ngIf="timeline && selectedSeasonId">
          <h3 *ngIf="
              timeline.configure === 'at_the_end_of_every_event' ||
              timeline.configure === 'day'
            ">
            {{ 'filter_by_date' | translate }}
          </h3>
          <h3 *ngIf="timeline.configure === 'month'">{{ 'filter_by_month' | translate }}</h3>
          <h3 *ngIf="timeline.configure === 'week'">{{ 'filter_by_week' | translate }}</h3>
          <div id="st-leaderboardsidebar-timeline-options-list" class="timeline-options-list" *ngIf="
              timeline.configure === 'at_the_end_of_every_event' ||
              timeline.configure === 'day'
            ">
            <label *ngFor="let item of getTimelineArray(timeline); trackBy: trackById" class="timeline-option">
              <input type="radio" name="timeline" [value]="item.date" [(ngModel)]="selectedTimelineId" />
              {{ item.date }}
            </label>
          </div>
          <div id="st-leaderboardsidebar-timeline-options-list-2" class="timeline-options-list" *ngIf="timeline.configure === 'month'">
            <label *ngFor="let item of getTimelineArray(timeline); trackBy: trackById" class="timeline-option">
              <input type="radio" name="timeline" [value]="item.date" [(ngModel)]="selectedTimelineId" />
              {{ item.month_label }}
            </label>
          </div>
          <div id="st-leaderboardsidebar-timeline-options-list-3" class="timeline-options-list" *ngIf="timeline.configure === 'week'">
            <label *ngFor="let item of getTimelineArray(timeline); trackBy: trackById" class="timeline-option">
              <input type="radio" name="timeline" [value]="item.date" [(ngModel)]="selectedTimelineId" />
              {{ item.week_label }}
            </label>
          </div>
        </div>
      </div>
      <div id="st-leaderboardsidebar-block-4" *ngIf="activeTab === 'rank'">
        <h3>{{ 'filter_by_rank' | translate }}</h3>
        <div id="st-leaderboardsidebar-rank-options" class="rank-options">
          <label *ngFor="let option of filteredRankOptions; trackBy: trackById" class="rank-option">
            <input type="radio" name="rank" [value]="option" [(ngModel)]="selectedRank"
              (change)="onRankSelect(option)" />
            {{ option }}
          </label>
        </div>
      </div>
      <div id="st-leaderboardsidebar-block-5" *ngIf="activeTab === 'event'">
        <h3>{{ 'filter_by_event' | translate }}</h3>
        <label class="season-label" for="eventSeason">{{ 'select_a_season' | translate }}</label>
        <select id="eventSeason" class="season-dropdown" [(ngModel)]="eventTabSeasonId"
          (ngModelChange)="onEventSeasonSelect($event)">
          <option value="">{{ 'none' | translate }}</option>
          <option *ngFor="let season of seasons; trackBy: trackById" [value]="getSeasonIdValue(season.id)">
            {{ season.season_name }}
          </option>
        </select>
        <div id="st-leaderboardsidebar-event-options" class="event-options" *ngIf="events.length > 0; else noEventResults">
          <label *ngFor="let event of events; trackBy: trackById" class="event-option">
            <input type="checkbox" [checked]="selectedEvents[event.event_id]"
              (change)="onEventSelect(event.event_id)" />
            {{ event.event_name }}
          </label>
        </div>
        <ng-template #noEventResults>
          <p>{{ 'no_events_found_for_season' | translate }}</p>
        </ng-template>
      </div>
    </div>
  </div>
  <div id="st-leaderboardsidebar-sidebar-footer" class="sidebar-footer">
    <button class="clear-btn" (click)="clearFilters()" (keydown.enter)="clearFilters()" (keydown.space)="$event.preventDefault(); clearFilters()" tabindex="0">{{ 'clear_all' | translate }}</button>
    <button class="apply-btn" (click)="applyFiltersHandler()" (keydown.enter)="applyFiltersHandler()" (keydown.space)="$event.preventDefault(); applyFiltersHandler()" tabindex="0">{{ 'apply' | translate }}</button>
  </div>
</div>